export default __webpack_public_path__ + "static/media/simProfile-8.ca9905ac.png";